
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PouchFilterEntity } from '../../domain/entities/PouchFilterEntity'
export class PouchFilterModel extends PouchFilterEntity {
  driverId?: number
  regionId?: number
  transactionsFromDate?: string
  transactionsToDate?: string
  userId?: string
  constructor(dataDto: PouchFilterEntity) {
    super()
    mapEntityProperties<PouchFilterModel>(this, dataDto, {
      exclude: ['driver', 'region', 'transactionStartDate', 'transactionEndDate'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id,
        transactionsFromDate: dataDto.transactionStartDate,
        transactionsToDate: dataDto.transactionEndDate,
        userId: dataDto.user?.id
      }
    })
  }
}